import { Component, OnInit, Input } from '@angular/core';
import { SmartModalService } from 'app/core/services/smart-modal.service';
import { FormControl, Validators, FormGroup, FormArray } from '@angular/forms';
import { RxComponent } from 'app/shared/components/common/rx.component';

@Component({
  selector: 'itpx-content-updated-info-edcast',
  template: `
  <p *ngIf="!data.html">{{data.text | translate}}</p>
  <div *ngIf="data.html" [innerHTML]="data.text | translate | keepHtml"></div>
  <form [formGroup]="form">
  <table class="table table-striped table-bordered table-hover" *ngIf="data.table">
  <thead>
    <tr>
      <th>
      <label>
      <input type="checkbox" class="checkbox" [formControl]="selectAll" [checked]="selectAllChecked">
    </label>
    </th>
      <th>Name</th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let option of options">
      <td>
      <label>
              <input type="checkbox" class="checkbox" [formControlName]="option.key" [checked]="option.checked" [id]="option.key">
            </label>
      <!-- <input type="checkbox" [(ngModel)]="option.checked" class="checkbox" /> -->
      </td>
      <td><label [for]="option.key">{{option.name}}</label></td>
    </tr>
    </tbody>
  </table>
  </form>
  <div *ngIf="data.html && data.text2" [innerHTML]="data.text2 | translate | keepHtml"></div>
  <div class="row">
      <div class="centered">
          <div class="button-form col-md-12">
              <button type="button" (click)="onNo()" class="btn btn-edcast-negative">
                  {{ data.btnNoText ? data.btnNoText :  'No'}}
              </button>
              <button type="button" (click)="onYes()" class="btn btn-edcast-positive" [disabled]="disableButton">
                  {{ data.btnYesText ? data.btnYesText :  'Yes'}}
              </button>
          </div>
      </div>
  </div>
`, styleUrls: ['./content-updated-info-edcast.component.css']
})
export class ContentUpdatedInfoEdcastComponent extends RxComponent implements OnInit {
  disableButton: boolean;

  @Input() private data: any;
  private options = [];
  private form: FormGroup;
  private selectAllChecked: boolean;
  private selectAll: FormControl;

  constructor(private modalService: SmartModalService, ) { super(); }

  ngOnInit() {
    if (this.data.table)
      this.data.table.forEach((d, idx) => {
        this.options.push({ name: d.name, value: d, checked: false, key: idx });
      });
    this.selectAllChecked = this.options.filter(it => true === it.checked).length === this.options.length;
    this.selectAll = new FormControl(this.selectAllChecked);

    this.form = this.toFormGroup(this.options);
    this.disableButton = !this.options.some(it => it.checked);

    this.selectAll.valueChanges.bindToLifecycle(this)
      .subscribe(res => {
        let input = {};
        Object.keys(this.form.controls).map(itr => input[itr] = res);
        this.form.setValue(input);
      });

    this.form.valueChanges.bindToLifecycle(this).subscribe(status => {
      this.selectAllChecked = Object.keys(status).every(it => status[it]);
      this.disableButton = !Object.keys(status).some(it => status[it]);
      this.options.forEach(it => it.checked = status[it.key]);
      this.selectAll.setValue(this.selectAllChecked,
        { emitEvent: false })
    });

  }

  toFormGroup(questions: any[]) {
    let group: any = {};

    questions.forEach(question => {
      group[question.key] = new FormControl(question.checked || false);
    });
    return new FormGroup(group);
  }

  private onYes() {
    this.modalService.sendResult(this.options.filter(f => f.checked).map(f => f.value));
  }

  private onNo() {
    this.modalService.sendResult(null);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/modal/content-updated-info-edcast/content-updated-info-edcast.component.ts